<template>
  <WrapWithHint tag="span" :content="hint">
    <span class="chip locked-chip">
      <i class="fa fa-lock"></i>
      <span class="is-sr-only">Locked</span>
    </span>
  </WrapWithHint>
</template>

<script setup>import { computed as _computed } from 'vue';

  import WrapWithHint from "./wrap-with-hint.vue";

  const props = defineProps({
    canUnlock: { type: Boolean, default: false },
    subrecipeIngredient: { type: Boolean, default: false },
  });

  const hint = _computed(() => {
    if (props.subrecipeIngredient) {
      const unlock = props.canUnlock
        ? "To edit the recipe, choose Unlock Recipe in More on its Recipe tab."
        : "The account owner can unlock the recipe in More on its Recipe tab.";
      return `This subrecipe's Recipe tab is read-only. Its measures can still be edited. ${unlock}`;
    }

    const unlock = props.canUnlock
      ? "To edit it, choose Unlock Recipe in Actions."
      : "The account owner can unlock it in Actions.";
    return `The Recipe tab is read-only. ${unlock}`;
  });
</script>
